interface EmptyStateProps {
  isSearch: boolean;
  onAdd: () => void;
}

export function EmptyState({ isSearch, onAdd }: EmptyStateProps) {
  if (isSearch) {
    return (
      <div className="text-center py-16 animate-fade-in">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted/60 mb-4">
          <svg
            className="w-7 h-7 text-muted-foreground/60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </div>
        <h3
          className="text-lg font-semibold text-muted-foreground mb-1"
          style={{ fontFamily: "var(--font-display)", fontWeight: 600 }}
        >
          Ничего не найдено
        </h3>
        <p
          className="text-sm text-muted-foreground/70"
          style={{ fontFamily: "var(--font-body)" }}
        >
          Попробуйте изменить поисковый запрос
        </p>
      </div>
    );
  }

  return (
    <div className="text-center py-16 animate-fade-in">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/5 border-2 border-dashed border-primary/20 mb-5">
        <svg
          className="w-9 h-9 text-primary/40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" />
          <line x1="6" x2="18" y1="17" y2="17" />
        </svg>
      </div>
      <h3
        className="text-xl font-semibold mb-2"
        style={{ fontFamily: "var(--font-display)", fontWeight: 600 }}
      >
        Пока нет рецептов
      </h3>
      <p
        className="text-sm text-muted-foreground/70 mb-6 max-w-xs mx-auto"
        style={{ fontFamily: "var(--font-body)" }}
      >
        Добавьте свой первый рецепт, чтобы начать собирать коллекцию
      </p>
      <button
        onClick={onAdd}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors duration-200"
        style={{ fontFamily: "var(--font-body)" }}
      >
        <svg
          className="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14" />
          <path d="M12 5v14" />
        </svg>
        Добавить рецепт
      </button>
    </div>
  );
}
